<template>
  <div>
    <el-row>
      <el-col
        :span="24"
        style="margin-top: 20%; text-align: center;"
      >
        <img
          class="logo"
          src="../assets/LogoPIM.png"
          alt="Idilia PIM logo"
        >
        <div style="margin-left:42%;width:160px;">
          <!-- <mgt-login v-pre class="custom-login" /> -->
          <div class=" login login-container">
  <mgt-login v-pre id="mgtLogin">
    <div data-type="signed-out">
     
<div data-type="signed-out" style="font-weight: bold;">
 Sign In
</div>

    </div>
  </mgt-login>
</div>

        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script lang="ts" setup>
import { registerMgtLoginComponent } from "@microsoft/mgt-components";

registerMgtLoginComponent()
// import { useUserStore } from "@/store/UserStore";
// import { onMounted } from "vue";
// import { useRouter } from "vue-router";

// const UserStore = useUserStore()
// const router = useRouter();
// onMounted(() => {
//   if (UserStore.signedIn) {
//     router.push({ name: "Dashboard" });
//   }
// });
</script>
